module.exports = __webpack_public_path__ + "static/img/insurance-product-9.d6a79ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-product-9.png
// module id = qMId
// module chunks = 4